import React, { useEffect, useState } from "react";
import Pagination from "../components/Pagination";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Get, Delete, Post } from "../components/Axios/AxiosFunctions";
import { SpinnerRoundOutlined } from "spinners-react";
import { toast } from "react-toastify";
import AddAndEditCmsWebItemModal from "../components/AddAndEditCmsWebItemModal";
import { successIcon, warningIcon } from "../constant/imagepath";
import AlertModal from "../components/AlertModal";
import { NODE_URL, nodeImageUrl } from "../components/Config/apiURL";

const Testimonial = (props) => {
  const accessToken = useSelector((state) => state.globalReducer.accessToken);
  const [limit, setLimit] = useState(10);
  const [forUser, setForUser] = useState("mentor");
  const [pageNumber, setPageNumber] = useState(1);
  const [maxLength, setMaxLength] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(true);
  const [loading, setLoading] = useState("");
  const [imageAlt, setImageAlt] = useState("");
  const [itemArray, setItemArray] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [icon, setIcon] = useState("");
  const [iconDisplay, setIconDisplay] = useState(null);
  const [itemDetail, setItemDetail] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);

  const addUrl = NODE_URL(`admin/testimonials`);

  const authHeader = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const getWebTestimonials = async () => {
    const getApiURL = `${addUrl}?page=${pageNumber}&limit=${limit}`;
    setIsFetchingData(true);
    const responseData = await Get(getApiURL, accessToken);
    let maxLastLength =
      pageNumber === 1 ? pageNumber * limit : (pageNumber - 1) * limit;
    setMaxLength(maxLastLength);
    if (responseData !== undefined) {
      setItemArray(responseData.data.data);
    } else {
      setItemArray([]);
      toast.error("error");
    }
    setIsFetchingData(false);
  };

  useEffect(() => {
    getWebTestimonials();
  }, [pageNumber]);

  const HandleShowAlertModal = (e, index) => {
    setItemDetail({
      index: index,
      id: e,
    });
    setShowAlertModal(true);
  };
  const deleteHandler = async () => {
    const deleteApiUrl = `${addUrl}/${itemDetail.id}`;
    setSaveLoading(true);
    // setLoading(itemDetail.id);
    const responseData = await Delete(deleteApiUrl, null, authHeader);
    if (responseData !== undefined) {
      let arr = itemArray.slice();
      arr.splice(itemDetail?.index, 1);
      setItemArray(arr);
      toast.success("Item Deleted Successfully.");
      cancelHandler(setShowAlertModal);
    }
    setSaveLoading(false);
    // setLoading("");
  };

  const imgAuthHeader = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const uploadImages = async (event) => {
    if (event.target.files.length > 0) {
      setIcon(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (event) => {
        setIconDisplay(event.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const createFormdata = async () => {
    var formData = new FormData();
    formData.append("image", icon);
    formData.append("name", title);
    formData.append("description", description);
    formData.append("image_alt", imageAlt);
    formData.append("location", location);
    formData.append("user", forUser);
    return formData;
  };

  const addTestimonialHandler = async () => {
    setSaveLoading(true);
    let returnFormData = await createFormdata();
    const responseData = await Post(addUrl, returnFormData, imgAuthHeader);
    if (responseData !== undefined) {
      let oldData = itemArray.slice();
      oldData.push(responseData?.data?.data);
      setItemArray(oldData);
      toast.success("Item Successfully Added.");
      cancelHandler(setShowAddModal);
    }
    setSaveLoading(false);
  };

  const editItemHandler = async () => {
    const editUrl = `${addUrl}/${itemDetail.id}`;
    setSaveLoading(true);
    let returnFormData = await createFormdata();
    const responseData = await Post(editUrl, returnFormData, imgAuthHeader);
    if (responseData !== undefined) {
      let oldData = itemArray.slice();
      oldData.splice(itemDetail.index, 1, responseData?.data?.data);
      setItemArray(oldData);
      toast.success("Item Edit Successfully.");
      cancelHandler(setShowEditModal);
    }
    setSaveLoading(false);
  };

  const cancelHandler = async (setter) => {
    setter(false);
    setItemDetail({});
    setTitle("");
    setDescription("");
    setLocation("");
    setIcon("");
    setImageAlt("");
    setForUser("mentor");
    setIconDisplay(null);
  };

  return (
    <>
      {/* <!-- Begin Page Content --> */}
      <div className="container-fluid newMentorRequests">
        {/* <!-- Page Heading --> */}
        <h1 className="h3 mb-2 text-gray-800">Testimonial Items</h1>
        <p className="mb-4">Add and Edit Testimonial</p>

        {/* <!-- DataTales Example --> */}
        <div className="card shadow mb-4">
          <div className="card-header py-3 d-flex">
            <h6 className="m-0 font-weight-bold text-primary">
              Add Testimonial Item
            </h6>
            <div className="addBtn">
              <i
                className="fas fa-plus-circle"
                onClick={() => setShowAddModal(true)}
              ></i>
            </div>
          </div>
          <div className="card-body">
            {isFetchingData ? (
              <div className="col-md-12 darken-newMechanic on-loading">
                <SpinnerRoundOutlined
                  enabled={isFetchingData}
                  thickness={200}
                  color="#175092"
                />
              </div>
            ) : (
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Image</th>
                      <th>Image ALT</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>For</th>
                      <th>Location</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemArray.map((item, index) => {
                      return (
                        <>
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <img
                                style={{ width: "50px", height: "50px" }}
                                src={`${nodeImageUrl}/${item?.image}`}
                              />
                            </td>
                            <td>
                              {item?.image_alt?.length >= 15
                                ? `${item?.image_alt.substring(0, 15)}...`
                                : item?.image_alt}
                            </td>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <td>{item.user}</td>
                            <td>{item.location}</td>
                            <td>
                              <Button
                                className="btn btn-user btn-block btn-save"
                                onClick={() =>
                                  HandleShowAlertModal(item?._id, index)
                                }
                                disabled={loading}
                              >
                                {loading === item._id ? "loading" : " Delete"}
                              </Button>
                            </td>
                            <td>
                              <Button
                                className="btn btn-user btn-block btn-save"
                                onClick={() => {
                                  setShowEditModal(true);
                                  setImageAlt(item.image_alt);
                                  setItemDetail({
                                    index: index,
                                    id: item?._id,
                                  });
                                  setTitle(item.name);
                                  setDescription(item.description);
                                  setLocation(item.location);
                                  setIcon(item.image);
                                  setForUser(item.user);
                                }}
                              >
                                Edit
                              </Button>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>

                <div className="pagination">
                  <Pagination
                    maxLastLength={maxLength}
                    array={setItemArray}
                    setPageNumber={setPageNumber}
                    pageNumber={pageNumber}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <!-- /.container-fluid --> */}

      <AddAndEditCmsWebItemModal
        title={"Add Testimonial"}
        type={"Testimonial"}
        visibleModal={showAddModal}
        itemTitle={title}
        setItemTitle={setTitle}
        itemDescription={description}
        setItemDescription={setDescription}
        itemLocation={location}
        setItemLocation={setLocation}
        imageAlt={imageAlt}
        setImageAlt={setImageAlt}
        icon={icon}
        iconDisplay={iconDisplay}
        onPress={() => {
          addTestimonialHandler();
        }}
        onPressCancel={() => {
          cancelHandler(setShowAddModal);
        }}
        itemLoading={saveLoading}
        uploadImages={uploadImages}
        setForUser={setForUser}
        forUser={forUser}
      />

      <AddAndEditCmsWebItemModal
        title={"Edit Testimonial"}
        type={"Testimonial"}
        visibleModal={showEditModal}
        itemTitle={title}
        setItemTitle={setTitle}
        itemDescription={description}
        setItemDescription={setDescription}
        itemLocation={location}
        setImageAlt={setImageAlt}
        imageAlt={imageAlt}
        setItemLocation={setLocation}
        icon={icon}
        iconDisplay={iconDisplay}
        onPress={() => {
          editItemHandler();
        }}
        onPressCancel={() => {
          cancelHandler(setShowEditModal);
        }}
        itemLoading={saveLoading}
        uploadImages={uploadImages}
        setForUser={setForUser}
        forUser={forUser}
      />
      <AlertModal
        title={"Alert!"}
        message={"Are you sure you want to delete this item?"}
        image={warningIcon}
        visibleModal={showAlertModal}
        onPress={() => {
          deleteHandler();
        }}
        onPressCancel={() => {
          cancelHandler(setShowAlertModal);
        }}
        itemLoading={saveLoading}
      />
    </>
  );
};

export default Testimonial;
